import React, { useState } from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import Form from './Form';

const StoriesSalesforce: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Tabs index={tabIndex} onChange={index => setTabIndex(index)}>
      <TabList>
        <Tab>Dados</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Form
            onCreated={() => {
              setTabIndex(1);
            }}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default StoriesSalesforce;
